/* eslint-disable */
const searchBar = () => {
    let base = themeVars.app_link ? themeVars.app_link : '';

    $(".js-search-box-form").each(function () {
        let thisForm = $(this);
        $(this).find(".country-select select").on("change", function () {
            let dataSrc = $(this)
                .find("option:selected")
                .attr("data-code-src");
            $(this)
                .closest(".country-select")
                .find(".countryFlag img")
                .attr("src", dataSrc);
        });

        $(this).find(".package_type").on("change", function () {
            let packVal = $(this).val();
            const currentSelect = $(this)[0][packVal];
            let setWeight = currentSelect.getAttribute('data-package-weight');
            thisForm.find(".goods_weight").val(setWeight);
        });

        $(this).on("submit", function (e) {
            e.preventDefault();
            let form = $(this),
                fromCountry = form.find(".from_country").val(),
                toCountry = form.find(".to_country").val(),
                stateFrom = form
                    .find(".from_country option:selected")
                    .attr("data-state-from"),
                stateTo = form.find(".to_country option:selected").attr("data-state-to"),
                zipFrom = form
                    .find(".from_country option:selected")
                    .attr("data-zip-from"),
                zipTo = form.find(".to_country option:selected").attr("data-zip-to"),
                weight = form.find(".goods_weight").val(),
                type = form.find('.package_type option:selected'),
                typeName = form.find('.package_type option:selected').attr("data-package-type");

            let urlParameters = {
                weight_kg: weight,
                height_cm: type.attr("data-package-height"),
                depth_cm: type.attr("data-package-depth"),
                width_cm: type.attr("data-package-width"),
                type: typeName.toUpperCase(),
                quantity: type.attr("data-package-quantity"),
                non_stackable: false,
                to_is_private: false,
                from_address_country_code: fromCountry,
                from_address_zip_code: zipFrom === undefined ? "" : zipFrom,
                from_address_state: stateFrom === undefined ? "" : stateFrom,
                to_address_country_code: toCountry,
                to_address_zip_code: zipTo === undefined ? "" : zipTo,
                to_address_state: stateTo === undefined ? "" : stateTo,
            };

            let urlSearchParams = new URLSearchParams(urlParameters).toString();
            let registerUrl = base + urlSearchParams;
            let validCountry = false;
            let validPackage = false;

            //validation
            let requiredCountry = themeVars.required_country ? (themeVars.required_country).toUpperCase() : '';

            if (
                urlParameters.from_address_country_code == requiredCountry ||
                urlParameters.to_address_country_code == requiredCountry
            ) {
                thisForm.find(".error-country").fadeOut();
                validCountry = true;
            } else {
                thisForm.find(".error-country").fadeIn();
                validCountry = false;
            }

            if (urlParameters.type === '0') {
                thisForm.find(".error-package").fadeIn();
                thisForm.find(".package_type").addClass("error_field");
                validPackage = false;
            } else {
                thisForm.find(".error-package").fadeOut();
                thisForm.find(".package_type").removeClass("error_field");
                validPackage = true;
            }
            if (validCountry === true && validPackage === true) {
                form[0].reset();
                window.open(registerUrl, "_self");
            } else {
                return false;
            }
        });
    });
}

export default searchBar;



// WEBPACK FOOTER //
// ./scripts/modules/search-bar.js